import { PaymentIntentMetadata, StripeItem } from "@/types/billing";
import { apiRequest } from "./request";
import { ICredit } from "@/types/user";

const getStripeProducts = () => apiRequest<StripeItem[]>("/billing/products", "GET");

const createPaymentIntent = (data: { priceId: string; stripeCustomerId: string; }) => apiRequest<{ id: string; clientSecret: string; amount: number; }>("/billing/create-payment-intent", "POST", data);

const processPayment = (data: { paymentIntentId: string; metadata?: PaymentIntentMetadata; }) => apiRequest<{ success: boolean; alreadyProcessed: boolean; userCredits: ICredit; promoCodeUsed: boolean; }>("/billing/process", "POST", data);

const sendReceipt = (data: { paymentIntentId: string; asEmail: boolean; }) =>
    apiRequest<{ receiptUrl: string; }>("/billing/send-receipt", "POST", data);

const validatePromoCode = (data: { promoCode: string; paymentIntentId: string; }) => apiRequest<{ promoCode: string; newAmount: number; percent_off: number; originalAmount: number; discount: number; }>("/billing/validate-promo-code", "POST", data);

const updatePaymentIntent = (data: { paymentIntentId: string; amount: number; metadata?: PaymentIntentMetadata; }) => apiRequest<{ id: string; clientSecret: string; amount: number; }>("/billing/update-payment-intent", "POST", data);

export default {
    getStripeProducts,
    createPaymentIntent,
    processPayment,
    sendReceipt,
    validatePromoCode,
    updatePaymentIntent
};